import { SchoolService } from '@services/school/school.service';
import { Component, OnInit } from '@angular/core';
import {User} from '@models/user';
import {BehaviorSubject} from '@node_modules/rxjs/internal/BehaviorSubject';
import {Subscription} from '@models/subscription';
import * as ProgramReducer from '@store/program/reducers';
import {Store} from '@node_modules/@ngrx/store';
import {SubscriptionService} from '@services/subscription/subscription.service';
import {MatDialog} from '@node_modules/@angular/material';
import {CreateProgramSubscriptionComponent} from '@pages/layout/program/program-page/program-payment/create-program-subscription/create-program-subscription.component';
import * as SubscriptionReducer from '@store/subscription/reducers';
import {ActionTypes, RemoveSubscription, SetSubscriptions} from '@store/subscription/actions';
import * as AuthReducer from '@store/auth/reducers';
import {ConfirmModalComponent} from '@components/confirm-modal/confirm-modal.component';
import {Curriculum} from '@models/curriculum';
import {forEach} from '@node_modules/@angular/router/src/utils/collection';

@Component({
  selector: 'app-subscription-page',
  templateUrl: './subscription-page.component.html',
  styleUrls: ['./subscription-page.component.scss']
})
export class SubscriptionPageComponent implements OnInit {
  usersSubject: BehaviorSubject<User> = new BehaviorSubject(null);
  subscriptions: Subscription[] = [];
  subscriptionsSearches: Subscription[];
  currentSubscription: Subscription;
  searchValue = '';
  confirmDialog;
  subscribes = [];
  user: User;
  subscriptionsStudents = {};
  schoolOwner: User;
  createDialog;
  subscriptionsLoading = true;
  isDarkTheme = false;
  constructor(
      public dialog: MatDialog,
      private authStore: Store<AuthReducer.AuthState>,
      private programStore: Store<ProgramReducer.ProgramState>,
      private subscriptionService: SubscriptionService,
      private schoolService: SchoolService,
      private subscriptionStore: Store<SubscriptionReducer.SubscriptionState>,
  ) {
  }

  ngOnInit() {
    this.isDarkTheme = localStorage.getItem('mkc-dashboard-theme') === 'dark';
    this.applyTheme();

    this.subscribes.push(this.authStore.subscribe(
        (val) => {
          const auth = val.auth;
          if (auth && auth.user) {
            this.user = auth.user;
            // console.log(auth);
            this.usersSubject.next(this.user);
          }
        }
    ));
    this.subscriptionStore.subscribe(
        resp => {
          if (resp.subscription) {
            if (resp.subscription.lastAction === ActionTypes.ADD_SUBSCRIPTION && resp.subscription.addedSubscription) {
              const addedSubscription = new Subscription(resp.subscription.addedSubscription);
              let found = false;
              this.subscriptions.map( item => {
                if (item.id === addedSubscription.id) {
                  found = true;
                }
              });
              if (found === false && (!this.isOwnerMembershipPage() || this.isVisibleMembership(addedSubscription))) {
                this.subscriptions.push(addedSubscription);
              }
            }
            if (resp.subscription.lastAction === ActionTypes.SET_SUBSCRIPTIONS || resp.subscription.lastAction === ActionTypes.UPDATE_SUBSCRIPTION) {
              this.subscriptions = this.isOwnerMembershipPage()
                ? this.toVisibleMemberships(resp.subscription.subscriptions)
                : this.toSubscriptions(resp.subscription.subscriptions);
              if (this.isOwnerMembershipPage() && this.subscriptionsSearches) {
                this.subscriptionsSearches = this.toVisibleMemberships(this.subscriptionsSearches);
              }
              this.currentSubscription = null;
            }
          }
        }
    );
    if(this.user.activeSchool){
      this.schoolService.getOwner(this.user.activeSchool).subscribe((res: any) => {
        if (res.status === 200) {
          this.schoolOwner = res.data;
        }
      });
    }
    if (this.user && !this.user.notAdmin) {
      this.getAllSubscriptions();
    }
  }
  searchSubscription(input) {
    if (input) {
      this.subscriptionsSearches
        = this.subscriptions.filter( subscription => !subscription.name.toLowerCase().search(this.searchValue.toLowerCase()));
    } else {
      this.searchValue = '';
      this.subscriptionsSearches = null;
    }
  }
  openCreateModalAction() {
    CreateProgramSubscriptionComponent.allSubscriptions = this.toVisibleMemberships(this.subscriptions);
    CreateProgramSubscriptionComponent.source = 'create';
    CreateProgramSubscriptionComponent.sourceEdit = null;
    this.createDialog = this.dialog.open(CreateProgramSubscriptionComponent, { disableClose: true });
    CreateProgramSubscriptionComponent.modalRef = this.createDialog;
    this.createDialog.afterClosed().subscribe(result => {
      this.createDialog.close();
    });
  }
  onOpenEditSubscription(event, subsc: Subscription) {
    event.stopPropagation();
    CreateProgramSubscriptionComponent.allSubscriptions = this.toVisibleMemberships(this.subscriptions);
    CreateProgramSubscriptionComponent.source = 'edit';
    CreateProgramSubscriptionComponent.sourceEdit = subsc;
    this.createDialog = this.dialog.open(CreateProgramSubscriptionComponent, { disableClose: true });
    CreateProgramSubscriptionComponent.modalRef = this.createDialog;
    this.createDialog.afterClosed().subscribe(result => {
      this.createDialog.close();
    });
  }

  onDelete(event, source: string, item) {
    event.stopPropagation();
    ConfirmModalComponent.insertedObject = this;
    ConfirmModalComponent.methodDelete = 'actionDelete';
    ConfirmModalComponent.methodDeleteParam = {source: source, item: item};
    ConfirmModalComponent.methodDeleteAllParam = true;
    this.confirmDialog = this.dialog.open(ConfirmModalComponent);
    ConfirmModalComponent.modalRef = this.confirmDialog;
    this.confirmDialog.afterClosed().subscribe(result => {
      this.confirmDialog.close();
    });
  }

  actionDelete(params) {
    try {
      this.subscribes.push(this.subscriptionService.removeSubscription(params.item).subscribe(
          (response: {data: any}) => {
            if (response) {
              console.log(response);
              if (response.data && response.data.exist) {
                ConfirmModalComponent.textModal = 'You can\'t delete subscription with ' + response.data.count + ' students';
                ConfirmModalComponent.source = 'info';
                ConfirmModalComponent.withButtons = false;
                ConfirmModalComponent.modalRef = this.dialog.open(ConfirmModalComponent);
              } else {
                this.subscriptionStore.dispatch(new RemoveSubscription(params.item));
              }
            }
          })
      );
    } catch (e) {
      console.log(e);
    }
  }

  removeSubscription(event, source: string, item) {
    event.stopPropagation();
    ConfirmModalComponent.textModal = 'Are you sure that you want to delete subscription ' + item.name + '?';
    ConfirmModalComponent.insertedObject = this;
    ConfirmModalComponent.methodDelete = 'actionDelete';
    ConfirmModalComponent.methodDeleteParam = {source: source, item: item};
    ConfirmModalComponent.methodDeleteAllParam = true;
    this.confirmDialog = this.dialog.open(ConfirmModalComponent);
    ConfirmModalComponent.modalRef = this.confirmDialog;
    this.confirmDialog.afterClosed().subscribe(result => {
      this.confirmDialog.close();
    });
  }
  getAllSubscriptions() {
    this.subscribes.push(this.subscriptionService.getByschool(null, ['invisible'] ).subscribe(
        (resp: {data: Subscription[]}) => {
          const subscriptions = this.isOwnerMembershipPage()
            ? this.toVisibleMemberships(resp.data)
            : this.toSubscriptions(resp.data);
          const ids = subscriptions.map(subscription => subscription.id);
          if (ids.length > 0) {
            this.subscriptionService.getSubscriptionUsers(ids).subscribe(
                (resp: {data: any}) => {
                  resp.data.map( subscr => {
                    this.subscriptionsStudents[subscr.subscription_id] = subscr.all_users;
                  });
                }
            );
          }
          this.subscriptionStore.dispatch(new SetSubscriptions(subscriptions));
          this.subscriptionsLoading = false;
        },
        () => {
          this.subscriptionsLoading = false;
        }
    ));
  }
  onViewSubscriptionUser(subscr: Subscription) {
    event.stopPropagation();
    CreateProgramSubscriptionComponent.allSubscriptions = this.toVisibleMemberships(this.subscriptions);
    CreateProgramSubscriptionComponent.source = 'view';
    CreateProgramSubscriptionComponent.sourceEdit = subscr;
    this.createDialog = this.dialog.open(CreateProgramSubscriptionComponent);
    CreateProgramSubscriptionComponent.modalRef = this.createDialog;
    this.createDialog.afterClosed().subscribe(result => {
      this.createDialog.close();
    });
  }

  getFrequency(subscr: Subscription) {
    if (subscr.isOnDemandType()) {
      return 'on demand';
    }

    const amount = subscr.frequency_amount > 1
      ? subscr.frequency_amount + ' '
      : '';

    let name = subscr.frequency_name;
    if (subscr.frequency_amount > 1) {
      name += 's';
    }

    return [amount, name].join('');
  }

  isOwnerMembershipPage() {
    return this.user && !this.user.notAdmin && this.user.role !== 'super_admin';
  }

  isVisibleMembership(subscr: Subscription) {
    if (!subscr) {
      return false;
    }

    const membership = subscr instanceof Subscription ? subscr : new Subscription(subscr);
    const name = membership.name ? membership.name.toLowerCase().trim() : '';

    return name !== 'invisible' && !membership.isInvisible();
  }

  toSubscriptions(rawSubscriptions: any): Subscription[] {
    if (!rawSubscriptions) {
      return [];
    }

    const subscriptions = Array.isArray(rawSubscriptions)
      ? rawSubscriptions
      : Object.keys(rawSubscriptions).map(key => rawSubscriptions[key]);

    return subscriptions
      .filter(subscription => !!subscription)
      .map(subscription => subscription instanceof Subscription ? subscription : new Subscription(subscription));
  }

  toVisibleMemberships(rawSubscriptions: any): Subscription[] {
    return this.toSubscriptions(rawSubscriptions).filter(subscription => this.isVisibleMembership(subscription));
  }

  getSubscriberCount(subscr: Subscription) {
    const storedCount = subscr && subscr.id ? this.subscriptionsStudents[subscr.id] : null;

    if (Array.isArray(storedCount)) {
      return storedCount.length;
    }

    if (storedCount !== null && storedCount !== undefined && storedCount !== '' && !isNaN(Number(storedCount))) {
      return Number(storedCount);
    }

    return subscr && subscr.users ? subscr.users.length : 0;
  }

  getSubscriberLabel(subscr: Subscription) {
    const count = this.getSubscriberCount(subscr);
    const studentLabel = count === 1 ? 'Student' : 'Students';

    return count + ' ' + studentLabel + ' Subscribed';
  }

  getMembershipPriceLabel(subscr: Subscription) {
    const paymentPrice = subscr ? subscr.payment_price : null;
    const price = Number(paymentPrice);
    const priceIsEmpty = paymentPrice === null
      || paymentPrice === undefined
      || paymentPrice === ''
      || (typeof paymentPrice === 'string' && paymentPrice.trim() === '');

    if (priceIsEmpty || isNaN(price) || !isFinite(price)) {
      return 'Price not set';
    }

    return '$' + price.toFixed(2) + '/' + this.getFrequency(subscr);
  }

  setTheme(theme: 'light' | 'dark') {
    this.isDarkTheme = theme === 'dark';
    localStorage.setItem('mkc-dashboard-theme', theme);
    this.applyTheme();
  }

  private applyTheme() {
    const shell = document.getElementById('page-wrapper');
    if (shell) {
      shell.classList.toggle('theme-dark', this.isDarkTheme);
    }
    document.documentElement.classList.add('mkc-dashboard-shell');
    document.body.classList.add('mkc-dashboard-shell');
    document.documentElement.classList.toggle('mkc-theme-dark', this.isDarkTheme);
    document.body.classList.toggle('mkc-theme-dark', this.isDarkTheme);
  }

  // sortSubscriptions(subscr: Subscription[]) {
  //   let programsSubscriptions = [];
  //   let otherSubscription = [];
  //   subscr.map( subscription => {
  //     if (this.checkSubscription(subscription)) {
  //       programsSubscriptions.push(subscription);
  //     } else {
  //       otherSubscription.push(subscription);
  //     }
  //   });
  //   programsSubscriptions.sort( (a,b) => {
  //     return a.name > b.name ? 1 : -1;
  //   });
  //   otherSubscription.sort( (a,b) => {
  //     return a.name > b.name ? 1 : -1;
  //   });
  //   return programsSubscriptions.concat(otherSubscription);
  // }
}
